import { SUBSCRIPTION } from "constants/action-types";
import { handleActions } from "redux-actions";

const initialState = {
    subscriptions: {},
    subscriptionsFetching: false,
    subscriptionsError: undefined,
};

export interface ISubscription {
    user_id: string;
    target_type: string;
    target_feed_id: string;
    target_feed_name: string;
    subscribed_at: string;
    meta: object;
}

export interface ISubscriptions {
    [id: string]: ISubscription;
}

interface IState {
    subscriptions: ISubscriptions;
    subscriptionsFetching: boolean;
    subscriptionsError: any;
}

export const subscriptions = handleActions(
    {
        [SUBSCRIPTION.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                subscriptionsFetching: true,
            };
        },
        [SUBSCRIPTION.FETCH.SUCCESS]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                subscriptions: {
                    ...state.subscriptions,
                    ...payload.results,
                },
                subscriptionsFetching: false,
            };
        },
        [SUBSCRIPTION.FETCH.ERROR]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                subscriptionsFetching: false,
                subscriptionsError: payload.error,
            };
        },
        [SUBSCRIPTION.SUBSCRIBE.SUCCESS]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                subscriptions: {
                    ...state.subscriptions,
                    ...payload.results,
                },
                subscriptionsFetching: false,
            };
        },
        [SUBSCRIPTION.UNSUBSCRIBE.SUCCESS]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                subscriptions: {
                    ...state.subscriptions,
                    ...payload.results,
                },
                subscriptionsFetching: false,
            };
        },
    },
    initialState,
);
